import SelectCreditCardPage from './SelectCreditCardPage';

export default SelectCreditCardPage;
